var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.28369C11.54 3.28369 11.07 3.32369 10.6 3.42369C7.84001 3.95369 5.64001 6.18369 5.12001 8.94369C4.64001 11.5537 5.60001 13.9537 7.34001 15.5037C7.77001 15.8837 8.00001 16.4137 8.00001 16.9737V19.2837C8.00001 20.3837 8.90001 21.2837 10 21.2837H10.28C10.63 21.8837 11.26 22.2837 12 22.2837C12.74 22.2837 13.38 21.8837 13.72 21.2837H14C15.1 21.2837 16 20.3837 16 19.2837V16.9737C16 16.4237 16.22 15.8837 16.64 15.5137C18.09 14.2337 19 12.3637 19 10.2837C19 6.41369 15.87 3.28369 12 3.28369ZM14 17.2837H10V16.2837H14V17.2837ZM10 19.2837V18.2837H14V19.2837H10ZM15.31 14.0237C15.22 14.1037 15.15 14.2037 15.07 14.2837H8.92001C8.84001 14.1937 8.77001 14.0937 8.68001 14.0137C7.36001 12.8337 6.77001 11.0737 7.09001 9.31369C7.45001 7.37369 9.05001 5.76369 10.98 5.38369C11.32 5.31369 11.66 5.28369 12 5.28369C14.76 5.28369 17 7.52369 17 10.2837C17 11.7137 16.39 13.0737 15.31 14.0237Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.2837H11.5V14.2837H12.5V11.2837Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3795 9.15752L9.67239 9.86462L11.7937 11.9859L12.5008 11.2788L10.3795 9.15752Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.501 11.2889L12.2081 11.996L14.3294 9.87467L13.6223 9.16757L11.501 11.2889Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsm);
export default __webpack_public_path__ + "static/media/dsm.0f3ef6ed660e0f0ba11b75ce1add9ad5.svg";
export { ForwardRef as ReactComponent };